export default __webpack_public_path__ + "static/p1-f23091e4a211a89e00a5cb42b8e08662.png";